import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const commonService = {
  linkVivolloSession: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.linkVivolloSession,
      payload,
      headers,
      hasErrorHandler,
    }),

  getBlogPosts: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.getBlogPosts,
      payload,
      headers,
      hasErrorHandler,
    }),

  getCountryCodes: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.common.getCountryCodes,
      payload,
      headers,
      hasErrorHandler,
    }),

  getCountries: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.common.getCountries,
      payload,
      headers,
      hasErrorHandler,
    }),

  getCities: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.common.getCities,
      payload,
      headers,
      hasErrorHandler,
    }),

  getCountriesNew: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.common.getCountriesNew,
      payload,
      headers,
      hasErrorHandler,
    }),
  getTaxOffices: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.common.getTaxOffices,
      payload,
      headers,
      hasErrorHandler,
    }),

  getCampaignDataByCampaignId: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.getCampaignDataByCampaignId,
      payload,
      headers,
      hasErrorHandler,
    }),

  checkRedirect: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.checkRedirect,
      payload,
      headers,
      hasErrorHandler,
    }),

  createTicketPdf: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.createTicketPdf,
      payload,
      headers,
      hasErrorHandler,
    }),

  getLocalizedCountries: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.common.getLocalizedCountries,
      payload,
      headers,
      hasErrorHandler,
    }),

  getCurrencies: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.common.getCurrencies,
      payload,
      headers,
      hasErrorHandler,
    }),

  getLanguages: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.common.getLanguages,
      payload,
      headers,
      hasErrorHandler,
    }),
  getContactSubjects: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.getContactSubjects,
      payload,
      headers,
      hasErrorHandler,
    }),
  submitContactForm: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.submitContactForm,
      payload,
      headers,
      hasErrorHandler,
    }),

  getPersonalOffersCampaigns: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.getPersonalOffersCampaigns,
      payload,
      headers,
      hasErrorHandler,
    }),
  submitApiPartnershipForm: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.submitApiPartnershipForm,
      payload,
      headers,
      hasErrorHandler,
    }),
  emailSubscribe: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.emailSubscribe,
      payload,
      headers,
      hasErrorHandler,
    }),
  getInvitationLink: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.common.getInvitationLink,
      payload,
      headers,
      hasErrorHandler,
    }),
  getLocalizationByKey: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.common.getLocalizationByKey,
      payload,
      headers,
      hasErrorHandler,
    }),
  getQuickHelpQuestions: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.common.getQuickHelpQuestions,
      payload,
      headers,
      hasErrorHandler,
    }),
};
